import { CardItem } from 'src/app/components/Elements/Card';
import { CardRowText } from 'src/app/components/Elements/Card/CardRowText';
import { CollapsibleSection } from 'src/app/components/Elements/CollapsibleSection';
import type { FacilityHour } from 'src/app/types';

import { ContrastedTitle } from '..';

interface HoursSectionProps {
  hours: FacilityHour[];
  closingTimeFlavorText: string;
}

export const HoursSection = ({ hours, closingTimeFlavorText }: HoursSectionProps) => {
  return (
    <CardItem>
      <ContrastedTitle title={'Hours'} inOrderSummary={true} />
      <CollapsibleSection collapsedTitle={closingTimeFlavorText}>
        {hours.map(({ dayName, formattedHours, isScheduledDate }) => {
          const typographyVariant = isScheduledDate ? 'bodyBold' : 'body';
          return (
            <CardRowText
              leftText={dayName}
              rightText={formattedHours}
              leftTextVariant={typographyVariant}
              rightTextVariant={typographyVariant}
              noPadding
            />
          );
        })}
      </CollapsibleSection>
    </CardItem>
  );
};
